import { useCallback } from "react";
import { useAppSelector } from "../../app";
import useAnnotations from "../../annotation";
import useActiveDocument from "../../document/hooks/useActiveDocument";

const useRemoveActiveEntityAnnotations = (multipleGroupBlocks?: boolean) => {
  const activeEntity = useAppSelector((state) => state.appReducer.activeEntity);

  const { activeDocument } = useActiveDocument();

  const { annotationsForEntity, removeAnnotation } = useAnnotations({
    documentId: activeDocument?.id,
    entityId: activeEntity?.entityType.id,
    groupBlockIndex: activeEntity?.index,
  });

  return useCallback(() => {
    annotationsForEntity.forEach((annotation) => {
      removeAnnotation(annotation.id, !!multipleGroupBlocks, true);
    });
  }, [annotationsForEntity, removeAnnotation, multipleGroupBlocks]);
};

export default useRemoveActiveEntityAnnotations;
